export default "__VITE_ASSET__BvfR6kZr__"